// import { useState, useEffect } from "react";
// import dayjs from "dayjs";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { getPlanDates } from "api/dietPlan";
// import { CircularProgress, Box } from "@mui/material";

// function MuiDatePickerInput({ fetchDietPlan, dates, isLoading }) {
//   const [open, setOpen] = useState(false);
//   const [availableDates, setAvailableDates] = useState([]);
//   const [selectedDate, setSelectedDate] = useState(null);

//   useEffect(() => {
//     const fetchAvailableDates = async () => {
//       try {
//         const response = await getPlanDates();
//         setAvailableDates(response);
        
//         // Set the first and last date as selected date when availableDates is loaded
//         if (response && response.length > 0) {
//           const firstDate = response[0];
//           const lastDate = response[response.length - 1];
          
//           // Format: "firstDate - lastDate" or just single date if only one
//           const dateRangeText = response.length === 1 
//             ? dayjs(firstDate).format('DD/MM/YYYY')
//             : `${dayjs(firstDate).format('DD/MM/YYYY')} - ${dayjs(lastDate).format('DD/MM/YYYY')}`;
          
//           // You can set this to a state or use it as needed
//           console.log("Date range:", dateRangeText);
          
//           // Optionally set the first date as the initial selected date
//           setSelectedDate(dayjs(firstDate));
//         }
//       } catch (error) {
//         console.error("Error fetching available dates:", error);
//       }
//     };
//     fetchAvailableDates();
//   }, []);

//   const shouldDisableDate = (date) => {
//     if (!availableDates.length) return true;
//     const dateString = dayjs(date).format('YYYY-MM-DD');
//     return !availableDates.includes(dateString);
//   };

//   // Get first and last date from availableDates
// const getDateRangeDisplay = () => {
//     if (!dates || !dates.length) return "DD/MM/YYYY";

//     if (dates.length === 1) {
//       // Agar availableDates use kar rahe hain toh usi ko format karein
//       return dayjs(dates[0]?.fullDate).format('DD/MM/YYYY');
//     }

//     const firstDate = dayjs(dates[0]?.fullDate).format('DD/MM/YYYY');
//     const lastDate = dayjs(dates[dates.length - 1]?.fullDate).format('DD/MM/YYYY');

//     return `${firstDate} - ${lastDate}`;
//   };


//   console.log(dates);
//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <DatePicker
//         format="DD/MM/YYYY"
//         label={getDateRangeDisplay()}
//         value={selectedDate}
//         open={open}
//         onOpen={() => setOpen(true)}
//         onClose={() => !isLoading && setOpen(false)} 
//         onChange={(newDate) => {
//           setSelectedDate(newDate);
//           fetchDietPlan(newDate);
//         }}
//         shouldDisableDate={shouldDisableDate}
//         disabled={isLoading} // Disable picker while loading
//         slotProps={{
//           textField: {
//             onClick: () => !isLoading && setOpen(true), // Prevent opening while loading
//             placeholder: getDateRangeDisplay(),
//             sx: {
//               "& .MuiInputBase-root": { cursor: isLoading ? "not-allowed" : "pointer" },
//               "& .MuiInputBase-input": { cursor: isLoading ? "not-allowed" : "pointer" },
//             },
//             InputProps: {
//               endAdornment: isLoading ? (
//                 <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
//                   <CircularProgress size={20} />
//                 </Box>
//               ) : undefined,
//             },
//           },
//           actionBar: {
//             actions: ["today", "cancel", "accept"],
//           },
//           // Add loading overlay for the popup
//           popper: {
//             sx: {
//               '& .MuiPaper-root': {
//                 position: 'relative',
//               },
//             },
//           },
//         }}
//         // Custom render for loading state in popup
//         renderInput={(params) => {
//           if (isLoading && open) {
//             return (
//               <Box sx={{ 
//                 position: 'absolute', 
//                 top: '50%', 
//                 left: '50%', 
//                 transform: 'translate(-50%, -50%)',
//                 zIndex: 1300,
//                 bgcolor: 'rgba(255, 255, 255, 0.8)',
//                 borderRadius: 2,
//                 p: 2
//               }}>
//                 <CircularProgress />
//               </Box>
//             );
//           }
//           return null;
//         }}
//       />
//     </LocalizationProvider>
//   );
// }

// export default MuiDatePickerInput;


import { useState, useEffect } from "react";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider, PickersDay } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getPlanDates } from "api/dietPlan";
import { CircularProgress, Box, styled } from "@mui/material";

// Custom Styled Component
const HighlightedDay = styled(PickersDay, {
  shouldForwardProp: (prop) => prop !== "isHighlightedPlan" && prop !== "isToday",
})(({ theme, isHighlightedPlan, isToday }) => ({
  // 1. Agar date plan ka hissa hai (Blue highlight)
  ...(isHighlightedPlan && {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  }),
  // 2. Agar date AJ ki hai (Today)
  ...(isToday && {
    border: `5px solid ${theme.palette.secondary.main}`, 
    fontWeight: "bold",
    ...(isHighlightedPlan && {
       backgroundColor: theme.palette.primary.dark, 
       boxShadow: `0 0 5px ${theme.palette.secondary.main}`,
    })
  }),
}));

function MuiDatePickerInput({ fetchDietPlan, dates, isLoading }) {
  const [open, setOpen] = useState(false);
  const [apiAvailableDates, setApiAvailableDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    const fetchAvailable = async () => {
      try {
        const response = await getPlanDates();
        setApiAvailableDates(response || []);
      } catch (error) {
        console.error("Error:", error);
      }
    };
    fetchAvailable();
  }, []);

  const currentPlanDates = dates?.map(item => item.fullDate) || [];
  const todayStr = dayjs().format("YYYY-MM-DD");

  const getDateRangeDisplay = () => {
    if (!dates || !dates.length) return "DD/MM/YYYY";
    const firstDate = dayjs(dates[0].fullDate).format('DD/MM/YYYY');
    const lastDate = dayjs(dates[dates.length - 1].fullDate).format('DD/MM/YYYY');
    return dates.length === 1 ? firstDate : `${firstDate} - ${lastDate}`;
  };

  const shouldDisableDate = (date) => {
    if (!apiAvailableDates.length) return false;
    return !apiAvailableDates.includes(dayjs(date).format('YYYY-MM-DD'));
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        format="DD/MM/YYYY"
        label={getDateRangeDisplay()}
        value={selectedDate}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => !isLoading && setOpen(false)}
        onChange={(newDate) => {
          setSelectedDate(newDate);
          fetchDietPlan(newDate);
        }}
        shouldDisableDate={shouldDisableDate}
        disabled={isLoading}
        slots={{
          day: (props) => {
            const dateStr = props.day.format("YYYY-MM-DD");
            const isHighlightedPlan = currentPlanDates.includes(dateStr);
            const isToday = dateStr === todayStr;

            return (
              <HighlightedDay 
                {...props} 
                isHighlightedPlan={isHighlightedPlan} 
                isToday={isToday}
              />
            );
          },
        }}
        slotProps={{
          textField: {
            onClick: () => !isLoading && setOpen(true),
            placeholder: getDateRangeDisplay(),
            sx: {
              "& .MuiInputBase-root": { cursor: isLoading ? "not-allowed" : "pointer" },
            },
            InputProps: {
              endAdornment: isLoading ? (
                <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
                  <CircularProgress size={20} />
                </Box>
              ) : undefined,
            },
          },
        }}
      />
    </LocalizationProvider>
  );
}

export default MuiDatePickerInput;